<template>
  <div>
    <div class="status-flow" v-loading="loading">
      <div class="flow-item" v-for="(item, index) in statusList" :key="index">
        <div class="icon-wrapper">
          <img :src="item.img" alt="" />
        </div>
        <div class="content">
          <div class="label" :title="$lang(item.label)">{{ $lang(item.label) }}</div>
          <div class="value" :title="item.value">
            <count-to :start-val="0" :end-val="item.value" :duration="2000" separator="," />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
import notPrint from '../images/not_print.png'
import hasGet from '../images/has_get.png'
import hasSign from '../images/has_sign.png'
import noSign from '../images/no_sign.png'
import notGet from '../images/not_get.png'
import running from '../images/running.png'
import sending from '../images/sending.png'
import { reqStatusCount } from '@/api/module/dashboard'
import dayjs from 'dayjs'

export default {
  name: 'StatusFlow',
  inject: ['dateRange'],
  watch: {
    'dateRange.data': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getData()
        }
      },
      deep: true,
    },
  },
  components: {
    CountTo,
  },
  data() {
    return {
      loading: false,
      statusList: [
        { label: '未打印', value: 0, img: notPrint, key: 'num1' },
        { label: '未取件', value: 0, img: notGet, key: 'num2' },
        { label: '已取件', value: 0, img: hasGet, key: 'num3' },
        { label: '运输中', value: 0, img: running, key: 'num4' },
        { label: '派送中', value: 0, img: sending, key: 'num5' },
        { label: '已签收', value: 0, img: hasSign, key: 'num6' },
        { label: '拒签', value: 0, img: noSign, key: 'num7' },
      ],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const params = {
        startTime: dayjs(this.dateRange.data[0]).format('YYYY-MM-DD') + ' 00:00:00',
        endTime: dayjs(this.dateRange.data[1]).format('YYYY-MM-DD') + ' 23:59:59',
        customerCode: 1,
      }
      try {
        this.loading = true
        const res = await reqStatusCount(params)
        if (res.code === 1) {
          this.handleData(res.data)
        }
      } finally {
        this.loading = false
      }
    },
    handleData(res) {
      this.statusList.forEach((item) => {
        item.value = res[item.key] || 0
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.status-flow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  padding: 0;
  overflow-x: auto;
  background: transparent;
  box-shadow: none;
  gap: 20px;
  .flow-item {
    flex: 0 1 calc((100% - 6 * 20px) / 7);
    min-width: 160px;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 12px;
    padding-right: 12px;
    height: 86px;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;

    .icon-wrapper {
      width: 48px;
      height: 48px;
      font-size: 24px;
      img {
        width: 36px;
      }
    }

    .content {
      overflow: hidden;
      .label {
        font-size: 16px;
        color: #666666;
        margin-bottom: 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .value {
        font-size: 22px;
        font-weight: bold;
        color: #1d2129;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>
